// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dropdown-menu{z-index:1400}.dropdown-menu .dropdown-menu-element__control{background-color:initial;border:none}.dropdown-menu .dropdown-menu-element__control:hover{box-shadow:none;border-color:initial}", ""]);
// Exports
module.exports = exports;
